// extracted by mini-css-extract-plugin
export var accordion = "_b8-0";
export var chevron = "_b8-3";
export var closed = "_b8-2";
export var content = "_b8-4";
export var open = "_b8-1";
export var rotate = "_b8-5";